// extracted by mini-css-extract-plugin
export default {"wrap":"download-link_wrap__jxQng","icon":"download-link_icon__Kj+Q-","showIcon":"download-link_showIcon__qXEfF"};